import { getCategoryPropertyValueRecord } from '../../../helpers/category-property-value-record.helpers';
import { omit } from '../../../helpers/object.helpers';
import { isEqualCategoryPropertyValueRecord } from '../../../helpers/recipe.helpers';
import {
  IElementCategory,
  ElementCategoryID,
} from '../../../models/element-categories.model';
import { DEFAULT_QUANTITY_PROPERTIES } from '../../../models/element-quantities.model';
import { Orientation } from '../../../models/orientation.model';
import { thermalTransmittanceProperty } from '../properties';
import { slabProperties } from './slab.model';

const recipeFilter: IElementCategory['recipeFilter'] = (recipe, element) => {
  const category_property_value_record =
    getCategoryPropertyValueRecord(element);

  // Recipe category_property_value_record must be an EXACT to the element to appear
  return isEqualCategoryPropertyValueRecord(
    category_property_value_record,
    recipe.category_property_value_record,
  );
};

export const slab: IElementCategory = {
  id: ElementCategoryID.Slab,
  defaultSelectedQuantity: 'area_top',
  name: 'Slab',
  orientation: Orientation.Horizonal,
  properties: slabProperties,
  optionalProperties: [thermalTransmittanceProperty],
  recipeFilter,
  getQuantityProperties: () =>
    omit(DEFAULT_QUANTITY_PROPERTIES, 'density', 'mass', 'fill'),
  getElementPropertySelectionByProductId: () => undefined,
};
